module.exports = "/_next/static/chunks/images/giorgio-607d7d93421bbd076e31c6dcaa72434c.svg";